import { flexRender, RowData } from "@tanstack/react-table";

import {
  getCellClassName,
  getCellDataAttributes,
  IRydeCell,
} from "@ryde/shared";

export interface IGridRowCellProps<T extends RowData> {
  cell: IRydeCell<T, unknown>;
  customClassName?: string;
  isDraggedRow?: boolean;
}

export const GridTableCell = <T extends RowData>({
  cell,
  customClassName,
}: IGridRowCellProps<T>): JSX.Element => {
  return (
    <td
      key={cell.id}
      data-e2e-id={cell.id}
      className={getCellClassName(cell, customClassName)}
      {...getCellDataAttributes(cell)}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};
